import { I18N } from "aurelia-i18n";
import additionalFieldsService from "services/additionalFieldsService";
import { autoinject } from "aurelia-framework";
import { AdditionalFieldsSourceType } from "enums/additional-fields-source-type";
import routerHelper from "helpers/routerHelper";

@autoinject
export class FieldServiceAdditionalFields {

    public actions: any = {};
    public workOrderId: number = 0;
    public readonly: any = false;
    public additionalFieldsSource: number = AdditionalFieldsSourceType.FieldService;
    public saveAdditionalFieldsButton: boolean = true;

    constructor(private readonly i18n: I18N) {
    }

    public activate(params: any): any {
        this.bindViewModel(params.workOrderId, params.q);
    }

    public bindViewModel(workOrderId: number, queryString: string): void {
        const params = routerHelper.getQuerystring(queryString);
        this.readonly = !(params && params.readonly === "false");

        this.workOrderId = workOrderId;

        this.actions = {
            getAll: additionalFieldsService.getAllForFieldService.bind(this, this.workOrderId),
            setAll: additionalFieldsService.setAllForFieldService.bind(this, this.workOrderId)
        };
    }

}
